import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";
export const getChapters = createAsyncThunk(
  "get/chapters",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("chapterList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const addChapters = createAsyncThunk(
  "add/chapters",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addChapter", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const editChapters = createAsyncThunk(
  "edit/chapters",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editChapter", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const statusChangedChapter = createAsyncThunk(
  "statusChanged/chapters",
  async (payload, { rejectWithValue }) => {
    const response = await axiosInstance.patch("statusChangedChapter", payload);
    return response.data;
  }
);

export const saveChapter = createAsyncThunk(
  "save/chapters",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("savedAllChapter", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);

const chapterSlice = createSlice({
  name: "chapter",
  initialState: {
    chapters: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getChapters.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(getChapters.fulfilled, (state, action) => {
      state.chapters = action.payload;
      state.loading = true;
    });
  },
});

export default chapterSlice.reducer;
